import React from 'react';
import Chip from '@mui/material/Chip';
import { BorderColor } from '@mui/icons-material';


// Utility to determine label and color based on status string
const getStatusStyles = (status) => {
  switch (status.toLowerCase()) {
    case 'completed':
      return { label: 'Completed', color: 'success.main' };
    case 'missed':
      return { label: 'Missed', color: 'error.light' };
    case 'connected':
      return { label: 'Connected', color: 'success.main' };
    case 'not connected':
      return { label: 'Not Connected', color: 'error.dark' };
    case 'active':
      return { label: 'Active', color: 'success.main' };
    case 'inactive':
      return { label: 'Inactive', color: 'error.main' };
    case 'paid':
      return { label: 'Paid', color: 'success.main' };
    case 'unpaid':
      return { label: 'Unpaid', color: 'error.main' };
    case 'upi':
      return { label: 'UPI', color: 'grey' };
    case 'card':
      return { label: 'Card', color: 'orange' };
    case 'in hand':
      return { label: 'In Hand', color: 'green' };
    default:
      return { label: status, color: 'warning.light' };
  }
};


const PillComponent = ({ isActive, status, sx = {}, ...props }) => {
  const { label, color } = status
    ? getStatusStyles(status)
    : {
        label: isActive ? 'Inactive' : 'Active',
        color: isActive ? 'grey.500' : 'success.main',
      };

  return (
    <Chip
      label={label}
      size="small"
      outlined
      sx={{
        color: 'common.white',
        textTransform: 'capitalize',
        fontWeight: 500,
        fontSize: '0.75rem',
        bgcolor: color,
        ...sx,
      }}
      {...props}
    />
  );
};

export default PillComponent;